<template>
    <div>
        <text>{{ subOption.name }}</text>
        <text v-if="subOption['replacementPrice'] !== undefined && subOption.replacementPrice !== 0">+{{
            subOption.replacementPrice }}</text>
        <text v-else-if="subOption['replacementPrice'] === undefined && subOption.price != 0">+{{ subOption.price
            }}</text>
    </div>
</template>
<script>
export default {
    props: {
        subOption: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
    },
    methods: {
    }
}
</script>
<style lang="">

</style>